import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, CircularProgress, Button, Table, TableHead, TableBody, TableCell, TableRow, TableContainer, Pagination } from '@material-ui/core'
import { styled } from '@material-ui/core/styles';
import {csvFormat} from 'd3-dsv'

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"

import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import MyPopover from "../MyPopover"

import { Header, FiltersDisplay, FilterList, ItemPopover } from "./Suivi"
import { ModalTuto } from "./Home"

import CertifModal from "./CertifModal"

import NewCertifChart from "../NewCertifChart"


import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"


import searchIcon from "../../../images/searchIcon.svg"
import exportIcon from "../../../images/exportIcon.svg"
import filterIcon from "../../../images/filterIcon.svg"
import checkGreenRoundIcon from "../../../images/checkGreenRoundIcon.svg"
import closeRedRoundIcon from "../../../images/closeRedRoundIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import closeIcon from '../../../images/closeIcon.svg';



Moment.locale('fr')

const ActionList = ({ glbData, filters, setFilters, icebreakerQuestions }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [actItem, setActItem] = useState(null)
  const menuOpenClose = (item) => {
    if (item === actItem) {
      setActItem(null)
    } else {
      setActItem(item)
    }
  }

  return (
    <Box sx={{display:"flex", alignItems:"flex-start"}}>
      <Box sx={{
        minWidth:"220px",
        maxWidth:"350px",
        padding:"10px 20px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
        border: "1px solid black",
        background:"white",
      }}>
        {actEcole?.groupes?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.groupe[actLanguage]}
              onClick={() => {menuOpenClose("groupe")}} selected={actItem === "groupe"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "groupe" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                  datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.diplome === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.graduationYear[actLanguage]}
              onClick={() => {menuOpenClose("diplome")}} selected={actItem === "diplome"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "diplome" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                  datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {actEcole?.campus?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.campus[actLanguage]}
              onClick={() => {menuOpenClose("campus")}} selected={actItem === "campus"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "campus" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                  datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.progress[actLanguage]}
          onClick={() => {menuOpenClose("status")}} selected={actItem === "status"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "status" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.progressSub[actLanguage]}
              datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.level[actLanguage]}
          onClick={() => {menuOpenClose("level")}} selected={actItem === "level"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "level" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.levelSub[actLanguage]}
              datas={levelTypes} filterType="level" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
      </Box>
      <Hidden mdDown>
        {actItem !== null &&
          <Box sx={{
            marginLeft:"10px",
            maxWidth:"350px",
            minWidth:"200px",
            padding:"10px 20px",
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
            border: "1px solid black",
            background:"white",
          }}>
            {actItem === "groupe" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "campus" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "diplome" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "status" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.progressSub[actLanguage]}
                datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "level" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.levelSub[actLanguage]}
                datas={levelTypes} filterType="level" filters={filters} setFilters={setFilters}
              />
            }
          </Box>
        }
      </Hidden>
    </Box>
  )
}


let defautFilters = {
  groupes : [],
  campus : [],
  anneesDiplome : [],
  status : [],
  level : [],
}
let statusTypes = ['notStarted', 'inProgress', 'ended']
let levelTypes = ['notAcquired', 'rattrapage', 'inProgress', 'acquired']

const Certification = ({ }) => {

  const {
    ecoles,
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)


  const [dataLoaded, setDataLoaded] = useState(false)
  const [glbData, setGlbData] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const [filters, setFilters] = useState(defautFilters)

  const [selectedID, setSelectedID] = useState(null)

  const [nbrPage, setNbrPage] = useState(1)
  const [page, setPage] = useState(1)

  const [popoverFilters, setPopoverFilters] = useState(false)
  const popoverRef = useRef()

  const [modalCertif, setModalCertif] = useState(false)


  useEffect(() => {
    setDataLoaded(false)
    if (actEcole?.groupes?.length > 0) {
      let fetchData = []
      actEcole?.groupes?.forEach((g) => {
        if (g.icebreaker !== null && g.certification) {
          let ids = []
          g?.plan?.plan?.forEach((p) => {
            ids.push(p.id)
          })
          fetchData.push({
            groupeID : g.groupeID,
            ids : ids,
            icebreaker : g.icebreaker
          })
        }
      })
      if (fetchData.length > 0) {
        APIS.clientAdminSuivi({fetchData : fetchData}).then((result) => {
          if (result?.value?.length > 0) {
            let dataToPass = []
            result?.value?.forEach((d) => {
              if (d.isOk === true && d.contents && d.results) {
                let finalData = {groupeID : d.groupeID}

                //on rechercher les résultats pour chaque user
                d?.users?.forEach((user) => {
                  user.results = []
                  let nbrEndedModule = 0
                  d?.contents?.forEach((content) => {
                    let find = d.results.find((el) => el.contentID === content.id && el.userID === user.id)
                    if (find) {
                      user.results.push(find)
                      if (find?.isDone === true && find?.progress === 100) {
                        nbrEndedModule++;
                      }
                    }
                  });
                  if (nbrEndedModule === 0 || d?.contents?.length === 0) { //pas commencé
                    user.statusProgress = 0
                    user.status = 'notStarted'
                    user.level = 'inProgress'
                  } else if (nbrEndedModule === d?.contents?.length) { //tout terminé
                    user.statusProgress = 100
                    user.status = 'ended'
                  } else { //en cours
                    user.statusProgress = Math.round( (nbrEndedModule / d?.contents?.length) * 100 )
                    user.status = 'inProgress'
                    user.level = 'inProgress'
                  }
                });

                //on regarde les softskills
                let labelsContent = []
                d?.contents?.forEach((module) => {
                  module?.softSkills?.forEach((skill) => {
                    if (skill.value === 'oui') {
                      labelsContent.push(skill)
                    }
                  });
                })

                let labelsCertif = []
                let thisGroupCertification = actEcole?.groupes?.find((el) => el.groupeID === d?.groupeID)?.certification
                thisGroupCertification?.forEach((module) => {
                  module?.softSkills?.forEach((skill) => {
                    labelsCertif.push(skill)
                  })
                })
                //on filtre pour n'avoir que les softskills présent en certif
                labelsContent.filter((el) => {
                  let find = labelsCertif.find((el2) => el2.key === el.key)
                  if (find) {
                    return true
                  } else { return false }
                })

                labelsContent = labelsContent.sort(function (a, b) {
                  if (a.family < b.family) {
                    return -1;
                  }
                  if (a.family > b.family) {
                    return 1;
                  }
                  return 0;
                });

                let uniqueLabels = Array.from(new Set(labelsContent.map(a => a.key)))
                 .map(id => {
                   return labelsContent.find(a => a.key === id)
                 })


                finalData.labels = uniqueLabels

                d?.users?.forEach((user) => {
                  if (user?.status === "ended") {
                    let diplomeOK = false
                    let nbrErreurDiplome = 0
                    let nbrSoftSkills = 0;
                    thisGroupCertification?.forEach((content) => {
                      let findContentInResult = user?.results?.find((el) => el.contentID === content.id)
                      content?.softSkills?.forEach((softskill) => {
                        nbrSoftSkills++
                        let findResult = findContentInResult?.resultFin[softskill.key]
                        if (findResult?.score === undefined || findResult?.score === null || findResult?.score < softskill.validation) {
                          nbrErreurDiplome++
                        }
                      })
                    })
                    let nbrOKDiplome = nbrSoftSkills - nbrErreurDiplome;
                    let percentOK = (nbrOKDiplome/nbrSoftSkills)*100
                    if (percentOK >= 70) {
                      user.level = 'acquired'
                    } else if (percentOK >= 50) {
                      user.level = 'rattrapage'
                    } else {
                      user.level = 'notAcquired'
                    }
                  }
                })

                finalData.contents = d?.contents
                finalData.users = d?.users

                dataToPass.push(finalData)
              }
            });


            let finalData = {
              contents : [],
              users : [],
              labelsPerGroup : []
            }

            dataToPass.forEach((data) => {
              data?.contents?.forEach((content) => {
                finalData?.contents?.push(content)
              })
              data?.users?.forEach((user) => {
                finalData?.users?.push({...user, groupeIDForCertif : data?.groupeID})
              })
              finalData?.labelsPerGroup?.push({
                groupeID : data.groupeID,
                labels : data?.labels
              })
            })


            setGlbData(finalData)
            setDataLoaded(true)
          } else {
            setDataLoaded(false)
          }
        })
      }
    }
  }, [actEcole])

  useEffect(() => {
    if (glbData !== null) {
      let newArr = []
      if (glbData.contents && glbData.contents.length > 0 && glbData.users && glbData.users.length > 0) {
        glbData.users.forEach((res) => {
          let findSubGroup = actEcole?.groupes?.find((el) => el.groupeID === res?.groupeIDForCertif)
          let obj = {
            groupeID : res?.groupeIDForCertif,
            campusID : res?.campusID,
            userName : res.name,
            userID : res.id,
            //anneeDiplome : res.icebreakerResults?.diplome || null,
            anneeDiplome : res.icebreakerResults?.annees || null,
            diplome : findSubGroup?.diplome || "-",
            statusProgress : res.statusProgress,
            status : res.status,
            level : res.level,
            results : res.results
          }
          newArr.push(obj)
        })
      }

      //filtered
      if (filters.groupes.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.groupes.includes(el.groupeID)
        })
      }
      if (filters.campus.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.campus.includes(el.campusID)
        })
      }
      if (filters.anneesDiplome.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.anneesDiplome.includes(el.anneeDiplome)
        })
      }
      if (filters.status.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.status.includes(el.status)
        })
      }
      if (filters.level.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.level.includes(el.level)
        })
      }

      //on trie par ordre alphabétiques
      newArr = newArr.sort((a,b)=>a.userName.localeCompare(b.userName))

      setNbrPage(Math.ceil(newArr.length/25))
      setPage(1)

      //console.log(newArr)
      setFilteredData(newArr)
    }
  }, [glbData, filters])

  useEffect(() => {
    if (selectedID === null) {
      /*if (filteredData.length > 0) {
        setSelectedID(filteredData[0])
      }*/
    } else {
      //on cherche la selectedID dans le tableau
      let find = filteredData.find((el) => el.userID === selectedID?.userID)
      if (!find) {
        if (filteredData.length > 0) {
          setSelectedID(filteredData[0])
        } else {
          setSelectedID(null)
          if (modalCertif === true) {
            setModalCertif(false)
          }
        }
      }
    }
  }, [filteredData, selectedID, modalCertif])


  const getMaxYear = (data) => {
    //on trie par années
    let contentsByYear = [[], [], []]
    let resultsByYear = [[], [], []]
    let findSubGroup = actEcole?.groupes?.find((el) => el.groupeID === data?.groupeID)
    findSubGroup?.plan?.plan?.forEach((plan) => {
      if (Number.isInteger(parseInt(plan.annee))) {
        contentsByYear[parseInt(plan.annee)-1].push(plan)
      }
    })

    contentsByYear.forEach((year, index) => {
      if (year.length > 0) {
        year.forEach((module) => {
          let findInResults = data?.results?.find((el) => el.contentID === module.id)
          if (findInResults) {
            resultsByYear[index].push(findInResults.resultFin)
          }
        })
      }
    })

    let maxYear = 0;
    if (contentsByYear[1].length > 0 && contentsByYear[2].length > 0) {
      maxYear = 2
    } else if (contentsByYear[1].length > 0) {
      maxYear = 1
    }

    return maxYear
  }


  const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  const getDatasForChart = (data) => {

    let labels = []
    let datasets = []
    let labelsDotColors = []

    let labelsCategories = ['communication','efficacite','leadership']

    let contentsByYear = [[], [], []]
    let resultsByYear = [[], [], []]

    let findLabels = glbData?.labelsPerGroup?.find((el) => el.groupeID === data?.groupeID)?.labels
    findLabels?.forEach((label) => {
      labels.push(capitalizeFirstLetter(label.key))
      if (label?.family === labelsCategories[0]) {
        labelsDotColors.push("rgba(255, 81, 6, 1)")
      } else if (label?.family === labelsCategories[1]) {
        labelsDotColors.push("rgba(79, 57, 255, 1)")
      } else if (label?.family === labelsCategories[2]) {
        labelsDotColors.push("rgba(243, 144, 255, 1)")
      }
    })

    let findSubGroup = actEcole?.groupes?.find((el) => el.groupeID === data?.groupeID)
    findSubGroup?.plan?.plan?.forEach((plan) => {
      if (Number.isInteger(parseInt(plan.annee))) {
        contentsByYear[parseInt(plan.annee)-1].push(plan)
      }
    })

    contentsByYear.forEach((year, index) => {
      if (year.length > 0) {
        year.forEach((module) => {
          let findInResults = data?.results?.find((el) => el.contentID === module.id)
          if (findInResults) {
            resultsByYear[index].push(findInResults.resultFin)
          }
        })
      }
    })

    let finalsResultsByYear = [[], [], []]
    resultsByYear.forEach((year, index) => {
      if (contentsByYear[index].length > 0) {
        let findLabels = glbData?.labelsPerGroup?.find((el) => el.groupeID === data?.groupeID)?.labels
        findLabels?.forEach((label) => {
          let scoreTot = 0
          let nbrTot = 0
          year?.forEach((result) => {
            if (result[label?.key]?.score !== undefined) {
              nbrTot++
              scoreTot = scoreTot + result[label?.key]?.score;
            }
          })

          let score = 0
          if (nbrTot > 0) {
            score = scoreTot/nbrTot
          }

          finalsResultsByYear[index].push({key:label?.key, family:label?.family, score: score})
        });
      }
    })


    finalsResultsByYear.forEach((result, index) => {
      if (result.length > 0) {
        let arr = []
        let dashStyle = undefined
        if (index === 0) { //1ere année
          dashStyle = [2,2]
        } else if (index === 1) { //2eme année
          dashStyle = [6,6]
        }

        labelsCategories.forEach((cat) => {
          let arr = []
          result.forEach((res) => {
            if (res.family === cat) {
              arr.push(res.score)
            } else {
              arr.push(null)
            }
          })


          let bgColor = ""
          let borderColor = ""
          let tooltipText = ""
          if (cat === labelsCategories[0]) {
            bgColor = "rgba(255, 81, 6, 0.2)"
            borderColor = "rgba(255, 81, 6, 1)"
            tooltipText = "Innovation et\ncommunication"
          } else if (cat === labelsCategories[1]) {
            bgColor = "rgba(79, 57, 255, 0.2)"
            borderColor = "rgba(79, 57, 255, 1)"
            tooltipText = "Éfficacité\nopérationnelle"
          } else if (cat === labelsCategories[2]) {
            bgColor = "rgba(243, 144, 255, 0.2)"
            borderColor = "rgba(243, 144, 255, 1)"
            tooltipText = "Collaboration et\nleadership"
          }


          datasets.push({
            title : index,
            data : arr,
            fill : true,
            backgroundColor: bgColor,
            borderColor: borderColor,
            borderDash : dashStyle,
            borderWidth : 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            tooltipText: tooltipText,
          })
        })
      }
    })

    datasets = datasets.filter((el) => {
      let total = 0

      el?.data?.forEach((nbr) => {
        total += nbr
      })

      if (total === 0) { return false } else { return true }
    })

    //on regarde si on a des labels à supprimer
    let indexesToBeDeleted = []
    labels = labels.map((label, index) => {
      let total = 0
      datasets.forEach((data) => {
        total += data?.data[index]
      })
      if (total === 0) {
        indexesToBeDeleted.push(index)
        labelsDotColors[index] = "toDelete"
        return false
      } else {
        return label
      }
    })
    indexesToBeDeleted = indexesToBeDeleted.reverse();

    datasets.forEach((data) => {
      indexesToBeDeleted.forEach((i) => {
        data.data.splice(i, 1)
      })
    })

    datasets.forEach((data) => {
      let nbrNotNull = data?.data?.filter((el) => el !== null)?.length
      data.labelsNbr = nbrNotNull
      data?.data?.forEach((val, index) => {
        if (val === null) {
          data.data[index] = 0
        }
      })
    })

    labelsDotColors = labelsDotColors.filter((el) => el !== "toDelete")

    labels = labels.filter((el) => el !== false)

    //on doit réorganiser les datasets
    let firstIndexPerDataset = []
    datasets.forEach((data, index) => {
      firstIndexPerDataset.push({datasetIndex : index, firstNonZero : data?.data?.findIndex((el) => el > 0)})
    })
    firstIndexPerDataset = firstIndexPerDataset.sort(function(a, b) {
      if (a?.firstNonZero < b?.firstNonZero) return -1;
      if (a?.firstNonZero > b?.firstNonZero) return 1;
      return 0;
    });

    let newDatasets = []
    firstIndexPerDataset?.forEach((data, index) => {
      newDatasets.push(datasets[data?.datasetIndex])
    })

    datasets = newDatasets


    //on regarde pour lier les lignes
    let indexLabels = 0
    for (let d=0; d<datasets.length; d++) {
      //pour le premier dataset
      if (d === 0 && datasets?.length >= 2) { //pour le premier dataset
        let actDataset = datasets[d]
        let nextDataset = datasets[d+1]

        actDataset.data[actDataset?.labelsNbr] = nextDataset.data[actDataset?.labelsNbr]
      } else if (d === datasets?.length-1) { //pour le dernier dataset
        let actDataset = datasets[d]
        let firstDataset = datasets[0]
        actDataset.data[0] = firstDataset.data[0]
      } else {
        let actDataset = datasets[d]
        let nextDataset =  datasets[d+1]
        actDataset.data[indexLabels + datasets[d]?.labelsNbr] = nextDataset.data[indexLabels + datasets[d]?.labelsNbr]
      }

      indexLabels += datasets[d]?.labelsNbr
    }


    return {
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : undefined,
      withoutTooltips : false,
    }


  }

  const handleExport = () => {
    let filename = 'Export '+languageValues?.adminDashboard?.certification[actLanguage]+' ' + actEcole?.name + ', ' + Moment().format('DD/MM/YYYY') + ', ' + Moment().format('HH')+'h'+Moment().format('mm')
    const renameKeys = (keysMap, objs) => {
      for (let i=0; i<objs.length;i++) {
        let obj = objs[i]
        objs[i] = Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: obj[key] }
        }),
        {})
      }
      return objs
    }

    let fieldsRename = {
      userName : languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      diplome : languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      anneeDiplome : languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage],
      campus : languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      status : languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage],
      level : languageValues?.adminDashboard?.monitoringTable?.level[actLanguage],
    }
    let fieldsExport = [
      languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.level[actLanguage],
    ]

    let toAddToExport = JSON.parse(JSON.stringify(filteredData))
    toAddToExport.forEach((res) => {
      if (!res.anneeDiplome) {
        res.anneeDiplome = "-"
      }

      if (res.status === "notStarted") {
        res.status = languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]
      } else if (res.status === "inProgress") {
        res.status = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]+" "+res.statusProgress+"%"
      } else if (res.status === "ended") {
        res.status = languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]
      }

      if (res.level === "inProgress") {
        res.level = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
      } else if (res.level === "notAcquired") {
        res.level = languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]
      } if (res.level === "acquired") {
        res.level = languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]
      } if (res.level === "rattrapage") {
        res.level = languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]
      }

      let findCampus = actEcole?.campus?.find((el) => el.id === res.campusID)
      let textCampus = "-"
      if (findCampus?.name) {
        textCampus = findCampus?.name
      }
      res.campus = textCampus

    })

    let rename = renameKeys(fieldsRename,  toAddToExport);
    let csv = csvFormat(rename, fieldsExport);
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename+'.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const [viewGraph, setViewGraph] = useState(false)


  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>


      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        <Header
          title={languageValues?.adminDashboard?.certification[actLanguage]}
          dataLoaded={dataLoaded && glbData !== null && filteredData.length !== 0}
        />

        {(dataLoaded && glbData !== null) ? (
          <>
            <Box sx={{
              display:"flex",
              gap:"10px",
              justifyContent:"space-between",
            }}>
              <Box sx={{
                marginTop:"35px",
                display:"flex",
                gap:["8px", "8px", "15px", "15px"],
                flexDirection:["column", "column", "row", "row"],
                alignItems:"flex-start",
              }}>
                <Button
                  ref={popoverRef}
                  disabled={!dataLoaded}
                  variant="contained"
                  disableRipple
                  sx={{
                    height:"40px !important",
                    minHeight:"40px !important",
                    flexShrink:0,
                    textTransform:"none",
                    background:"white",
                    color:"text.black",
                    boxShadow:"none",
                    border:"1px solid #E7E7E7",
                    fontSize:"14px !important",
                    gap:"8px",
                    '&:hover': {
                      background:"white",
                      border:"1px solid black",
                    },
                  }}
                  onClick={() => { setPopoverFilters(true) }}
                >
                  <img src={searchIcon} style={{width:"14px"}} />
                  <span>
                    {languageValues?.adminDashboard?.filters?.addFilter[actLanguage]}
                  </span>
                </Button>
                <FiltersDisplay filters={filters} setFilters={setFilters} contents={glbData.contents} defaultF={defautFilters}/>
              </Box>
              <Button
                disabled={!dataLoaded}
                variant="contained"
                disableRipple
                sx={{
                  marginTop:"35px",
                  height:"40px !important",
                  minHeight:"40px !important",
                  flexShrink:0,
                  textTransform:"none",
                  background:"white",
                  color:"text.black",
                  boxShadow:"none",
                  border:"1px solid #E7E7E7",
                  fontSize:"14px !important",
                  gap:"8px",
                  minWidth:"0 !important",
                  '&:hover': {
                    background:"white",
                    border:"1px solid black",
                  },
                }}
                onClick={() => { handleExport() }}
              >
                <img src={exportIcon} style={{width:"15px"}} />
                <Hidden mdDown>
                  <span>
                    {languageValues?.adminDashboard?.exportTable[actLanguage]}
                  </span>
                </Hidden>
              </Button>
            </Box>

            <Box sx={{display:"flex", gap:selectedID === null ? "0%" : "2%", transition: "all 0.5s ease-out",}}>
              <Box sx={{flex : 1, flexShrink: 1,}}>

                { /* TABLE */}
                <TableContainer sx={{marginTop:"25px"}}>
                  <Table
                    sx={{ minWidth: '100%' }}
                  >
                    <TableHead>
                      <TableRow sx={{
                        background: "#FAF8F6",
                        '& th': {
                          color:"text.subTitle",
                          fontSize:"15px",
                          border:"1px solid #E7E7E7"
                        }
                      }}>
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.name[actLanguage]}
                        </TableCell>
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage]}
                        </TableCell>
                        <Hidden smDown>
                          {actEcole?.icebreakerQuestions?.diplome === true &&
                            <TableCell align="left" sx={{padding:"10px 16px", whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                              {languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage]}
                            </TableCell>
                          }
                        </Hidden>
                        <Hidden mdDown>
                          <TableCell align="left" sx={{padding:"10px 16px"}}>
                            {languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage]}
                          </TableCell>
                        </Hidden>
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage]}
                        </TableCell>
                        <Hidden smDown>
                          <TableCell align="left" sx={{padding:"10px 16px"}}>
                            {languageValues?.adminDashboard?.monitoringTable?.level[actLanguage]}
                          </TableCell>
                        </Hidden>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {filteredData.slice(
                      (page-1) * 25,
                      ((page-1) * 25) + 25
                    ).map((row, index) => {
                      let findCampus = actEcole?.campus?.find((el) => el.id === row.campusID)
                      let textCampus = "-"
                      if (findCampus?.name) {
                        textCampus = findCampus?.name
                      }
                      return (
                        <TableRow
                          key={index}
                          onClick={(e) => {
                            setSelectedID(row)
                            setModalCertif(true)
                          }}
                          sx={{
                            background : row.userID === selectedID?.userID ? "#F2F0EF" : "white",
                            cursor:"pointer",
                            '& td': {
                              border:"1px solid #E7E7E7",
                            }
                          }}
                        >
                          <Hidden smDown>
                            <TableCell sx={{fontSize:"13px", color:"text.black", textTransform:"capitalize"}}>
                              {row.userName}
                            </TableCell>
                          </Hidden>
                          <Hidden smUp>
                            <TableCell sx={{fontSize:"13px", textTransform:"capitalize"}}>
                              <Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
                                <Box sx={{fontSize:"13px", color:"text.black", textTransform:"capitalize"}}>{row.userName}</Box>
                                <Box sx={{fontSize:"12px", color:"text.subTitle", }}>{row.anneeDiplome ? row.anneeDiplome : "-"}</Box>
                              </Box>
                            </TableCell>
                          </Hidden>
                          <Hidden smDown>
                            {actEcole?.icebreakerQuestions?.diplome === true &&
                              <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                                {row.diplome ? row.diplome : "-"}
                              </TableCell>
                            }
                          </Hidden>
                          <Hidden smUp>
                            <TableCell>
                              <Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
                                <Box sx={{fontSize:"13px", color:"text.black",}}>{row.diplome ? row.diplome : "-"}</Box>
                                <Box sx={{fontSize:"12px", color:"text.subTitle",}}>
                                  {row?.level === 'notAcquired' &&
                                    <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                      <img src={closeRedRoundIcon} style={{width:"15px"}}/>
                                      <Box>
                                        <font>
                                          {languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                                        </font>
                                      </Box>
                                    </Box>
                                  }
                                  {row?.level === 'rattrapage' &&
                                    <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                      <img src={closeRedRoundIcon} style={{width:"15px"}}/>
                                      <Box>
                                        <font>
                                          {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                                        </font>
                                      </Box>
                                    </Box>
                                  }
                                  {row?.level === 'acquired' &&
                                    <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                      <img src={checkGreenRoundIcon} style={{width:"15px"}}/>
                                      <Box>
                                        <font>
                                          {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                                        </font>
                                      </Box>
                                    </Box>
                                  }
                                  {row?.level === 'inProgress' && languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                                </Box>
                              </Box>
                            </TableCell>
                          </Hidden>
                          <Hidden smDown>
                            <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                              {row.anneeDiplome ? row.anneeDiplome : "-"}
                            </TableCell>
                          </Hidden>
                          <Hidden mdDown>
                            <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                              {textCampus}
                            </TableCell>
                          </Hidden>
                          <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                            {row.status === "ended" &&
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                <img src={checkGreenRoundIcon} style={{width:"18px"}}/>
                                <Box>
                                  <Hidden mdDown>
                                    <font>
                                      {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                    </font>
                                  </Hidden>
                                </Box>
                              </Box>
                            }
                            {row.status === "inProgress" &&
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                <Box sx={{position:"relative"}}>
                                  <CircularProgress variant="determinate" value={100} thickness={5.5} size="18px" sx={{color: '#E7E7E7'}} />
                                  <CircularProgress
                                    variant="determinate"
                                    value={row.statusProgress}
                                    thickness={6}
                                    size="18px"
                                    sx={{
                                      color: "black",
                                      position: 'absolute',
                                      left: 0,
                                    }}
                                  />
                                </Box>
                                <Box>
                                  <Hidden mdDown>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                                    {row.statusProgress}%
                                  </Hidden>
                                  <Hidden mdUp>
                                    {row.statusProgress}%
                                  </Hidden>
                                </Box>
                              </Box>
                            }
                            {row.status === "notStarted" &&
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                <Box sx={{position:"relative"}}>
                                  <img src={sablierIcon} style={{height:"18px", marginLeft:"3px"}} />
                                </Box>
                                <Box>
                                  <Hidden mdDown>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                                  </Hidden>
                                  <Hidden mdUp>
                                    {row.statusProgress}%
                                  </Hidden>
                                </Box>
                              </Box>
                            }
                          </TableCell>
                          <Hidden smDown>
                            <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                              {row.level === 'notAcquired' &&
                                <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                  <img src={closeRedRoundIcon} style={{width:"18px"}}/>
                                  <Box>
                                    <Hidden mdDown>
                                      <font>
                                        {llanguageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                                      </font>
                                    </Hidden>
                                  </Box>
                                </Box>
                              }
                              {row.level === 'rattrapage' &&
                                <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                  <img src={closeRedRoundIcon} style={{width:"18px"}}/>
                                  <Box>
                                    <Hidden mdDown>
                                      <font>
                                        {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                                      </font>
                                    </Hidden>
                                  </Box>
                                </Box>
                              }
                              {row.level === 'acquired' &&
                                <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                  <img src={checkGreenRoundIcon} style={{width:"18px"}}/>
                                  <Box>
                                    <Hidden mdDown>
                                      <font>
                                        {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                                      </font>
                                    </Hidden>
                                  </Box>
                                </Box>
                              }
                              {row.level === 'inProgress' && languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                            </TableCell>
                          </Hidden>
                        </TableRow>
                      )
                    })}
                    </TableBody>
                  </Table>
                </TableContainer>
                { /* END TABLE */}

                { /* PAGINATION */}
                <Pagination
                  sx={{
                    display:"flex",
                    justifyContent:"center",
                    marginTop:"20px",
                    userSelect:"none",
                    '& .MuiPaginationItem-root' : {
                      color:"text.subTitle",
                    },
                    '& .MuiPaginationItem-root.MuiButtonBase-root' : {
                      background:"white",
                      border:"1px solid #E7E7E7",
                      color: "text.subTitle",
                      borderRadius:"0 !important",
                    },
                    '& .MuiPaginationItem-root.MuiButtonBase-root.Mui-selected' : {
                      background:"white",
                      border:"1px solid #E7E7E7",
                      color: "text.black",
                    },
                    '& .MuiPaginationItem-root.MuiButtonBase-root:hover' : {
                      background:"white",
                      color: "text.black",
                      border:"1px solid black",
                    },
                  }}
                  siblingCount={0}
                  boundaryCount={1}
                  count={nbrPage}
                  page={page}
                  shape="rounded"
                  onChange={(e, page) => {
                    if (page) {
                      setPage(page)
                      if (popoverRef && popoverRef.current) {
                        popoverRef.current.scrollIntoView()
                      }
                    }
                  }}
                />

                <Box sx={{
                  display:"flex",
                  justifyContent:"center",
                  marginTop:"15px",
                  color:"text.subTitle",
                  fontSize:'13px',
                }}>
                  {((page-1) * 25) + 1}
                  {'-'}
                  {((page-1) * 25) + 25 > filteredData.length ? filteredData.length : ((page-1) * 25) + 25}
                  {' sur '}
                  {filteredData.length}
                </Box>
                { /* END PAGINATION */}

              </Box>

              { /* RIGHT BOX FOR DESKTOP */}
              <Box
                id="flexTransitionDiv"
                onTransitionEnd={() => {
                  let actWidth = document?.getElementById("flexTransitionDiv")?.clientWidth
                  if (actWidth === 0) {
                    setViewGraph(false)
                  } else {
                    setViewGraph(true)
                  }
                }}
                sx={{position:"sticky", top:"0px", alignSelf:"flex-start", flexBasis : selectedID === null ? "0px" : "490px", transition: "all 0.5s ease-out", overflow:"hidden", flexShrink: 1, maxWidth:"490px", display:{xs : "none", lg:"flex"}}}
              >
                <Box sx={{width : "100%"}}>
                  <Box sx={{marginTop:"25px", background:"white", border:"1px solid #E7E7E7", width:"100%"}}>
                    <Box sx={{opacity:selectedID ? 1 : 0, padding:"30px 50px", overflow:"hidden", display:"flex", justifyContent:"space-between"}}>
                      <Box sx={{fontSize:"32px", padding:"20px 0px", color:"text.black", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis", textTransform:"capitalize"}}>
                        {selectedID?.userName}
                      </Box>
                      <Box>
                        <img
                          src={closeIcon}
                          style={{width:"18px", height:"18px", cursor:"pointer"}}
                          onClick={() => { setSelectedID(null); setModalCertif(false); }}
                        />
                      </Box>
                    </Box>
                    <Box sx={{opacity:selectedID ? 1 : 0, padding:"0px 50px", overflow:"hidden", display:"flex"}}>
                      <Box sx={{flex:0.55, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <Box sx={{color:"text.subTitle",}}>
                          {languageValues?.adminDashboard?.monitoringTable?.graduation[actLanguage]}
                        </Box>
                        <Box sx={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.diplome ? selectedID.diplome : "-"}
                        </Box>
                      </Box>
                      <Box sx={{flex:0.45, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <font style={{color:"text.subTitle",}}>
                          {languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage]}
                        </font>
                        <font style={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.anneeDiplome ? selectedID.anneeDiplome : "-"}
                        </font>
                      </Box>
                    </Box>
                    <Box sx={{
                      opacity:selectedID ? 1 : 0,
                      marginTop:"40px",
                      padding:"0px 50px",
                      paddingBottom:"0px",
                      overflow:"hidden",
                      display:"flex",
                      marginBottom:viewGraph ? "0px" : "40px",
                     }}>
                      <Box sx={{flex:0.55, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <font style={{color:"text.subTitle", }}>
                          {languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage]}
                        </font>
                        <font style={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.status === "ended" &&
                            <Box sx={{display:"flex", gap:"6px", height:"100%",}}>
                              <img src={checkGreenRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.status === "inProgress" &&
                            <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                              <Box sx={{position:"relative", height:"25px"}}>
                                <CircularProgress variant="determinate" value={100} thickness={5.5} size="20px" sx={{color: '#E7E7E7'}} />
                                <CircularProgress
                                  variant="determinate"
                                  value={selectedID.statusProgress}
                                  thickness={6}
                                  size="20px"
                                  sx={{
                                    color: "black",
                                    position: 'absolute',
                                    left: 0,
                                  }}
                                />
                              </Box>
                              <Box>
                                <Hidden mdDown>
                                  {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                                  {selectedID.statusProgress}%
                                </Hidden>
                                <Hidden mdUp>
                                  {selectedID.statusProgress}%
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.status === "notStarted" &&
                            <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                              <Box sx={{position:"relative", height:"20px"}}>
                                <img src={sablierIcon} style={{height:"20px", marginLeft:"4px"}} />
                              </Box>
                              <Box>
                                <Hidden mdDown>
                                  {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                                </Hidden>
                                <Hidden mdUp>
                                  {selectedID.statusProgress}%
                                </Hidden>
                              </Box>
                            </Box>
                          }
                        </font>
                      </Box>
                      <Box sx={{flex:0.45, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <font style={{color:"text.subTitle",}}>
                          {languageValues?.adminDashboard?.monitoringTable?.level[actLanguage]}
                        </font>
                        <font style={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.level === 'notAcquired' &&
                            <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                              <img src={closeRedRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.level === 'rattrapage' &&
                            <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                              <img src={closeRedRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.level === 'acquired' &&
                            <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                              <img src={checkGreenRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.level === 'inProgress' && languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                        </font>
                      </Box>
                    </Box>
                    {(selectedID && viewGraph) &&
                      <>
                        <NewCertifChart
                          datas={getDatasForChart(selectedID)}
                        />
                        <Box sx={{width:"100%", justifyContent:"center", gap:["20px", "40px"], color:"text.black", marginTop:'-10px', marginBottom:"20px", fontSize:["11px", "13px", "13px", "13px"], display:"flex"}}>
                          <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                            <Box sx={{width:['30px',' 40px'], borderTop:"2px dotted rgba(0, 0, 0, 0.6)"}} />
                            <Box>{languageValues?.adminDashboard?.dashCertif?.yearBtn[actLanguage]} 1</Box>
                          </Box>
                          <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                            <Box sx={{width:['30px',' 40px'], borderTop:"2px dashed rgba(0, 0, 0, 0.6)"}} />
                            <Box>{languageValues?.adminDashboard?.dashCertif?.yearBtn[actLanguage]} 2</Box>
                          </Box>
                          {getMaxYear(selectedID) >= 2 &&
                            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                              <Box sx={{width:['30px',' 40px'], borderTop:"2px solid rgba(0, 0, 0, 0.6)"}} />
                              <Box>{languageValues?.adminDashboard?.dashCertif?.yearBtn[actLanguage]} 3</Box>
                            </Box>
                          }
                        </Box>
                      </>
                    }
                  </Box>
                </Box>
              </Box>
              { /* END RIGHT BOX FOR DESKTOP */}


            </Box>

            <CertifModal
              isOpen={modalCertif}
              selectedID={selectedID}
              dataLoaded={dataLoaded}
              getDatasForChart={getDatasForChart}
              getMaxYear={getMaxYear}
              onClose={() => {
                setModalCertif(false)
                setTimeout(() => {
                  setSelectedID(null)
                }, 500)
              }}
            />


            <MyPopover
              isDrawerOpen={popoverFilters}
              anchorEl={popoverRef.current}
              handleClose={() => { setPopoverFilters(false) }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <ActionList
                glbData={glbData}
                filters={filters}
                setFilters={setFilters}
                icebreakerQuestions={actEcole?.icebreakerQuestions}
              />
            </MyPopover>
          </>
        ) : (
          <Box sx={{flex:1, height:"calc(100vh - 300px)", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <CircularProgress size="70px" sx={{'color': 'black'}} />
          </Box>
        )}


      </Box>

    </>
  )
}


export default Certification
